import AbstractElement from "../../pages/AbstractElement";

class TabItem extends AbstractElement {

    constructor(template: JQuery) {
        super(template);
    }

    init(): void {
        super.init();
    }
}

export default TabItem;